import React, { useState, useEffect } from 'react'
import { Input, Col, Row, Form, Checkbox, Select, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import RequestHandler from '../../util/RequestHandler';
import { odata } from '../Filters/Helper';
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const FirmAccountUpdate = (props) => {
  const [loading, setLoading] = useState(false);
  const [iban, setIban] = useState(props.iban);
  const [accountNumber, setAccountNumber] = useState(props.accountNumber);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [bankDropdown, setbankDropdown] = useState([]);

  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [form] = Form.useForm();

  const [currencyId, setCurrencyId] = useState(1);
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    RequestHandler.get(`/Bank?$filter=isEmoney ne true&$orderby=name`).then(res => {
      setbankDropdown(res.value.filter(x => x.id !== 999))
    });

    getCurrencies();

  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);

      if (props.data.firmId) {
        setFirmSelect({ data: [], loading: true });

        RequestHandler.get(`/Firm?$select=id,firmBranchNumber,name&$filter=id eq ${props.data.firmId}`).then(res => {
          setFirmSelect({ data: res.value, loading: false });
        });
      }

      if (props.data.bankId) {
        onBankChange(props.data.bankId);
      }

    }
  }, [props.data]);

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });

    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const onChangeCurrencyId = (value) => {
    setCurrencyId(value);
  }

  const onFinish = values => {
    RequestHandler.put(`/FirmAccount`, values)
    .then(response => {
      setLoading(false);
      if (response.success) {
        form.resetFields();
        if (props.onSuccess) props.onSuccess();
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };
  const onFinishFailed = () => setLoading(false);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(`/Firm?isFilter=true&$select=id,firmBranchNumber,name&$filter=${odata.contains("name", value)} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onBankChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(res => {
      setbankBranchDropdown(res);
    });
  }

  const handleAccountNumber = value => {
    setAccountNumber(value.target.value)
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }
  const handleIban = value => {
    setIban(value.target.value)
  };

  const { Option } = Select;
  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="firmAccountUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>

          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Form.Item
            label="Cari Adı/Ünvanı"
            name="firmId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="En az 2 harf giriniz.."
              optionFilterProp="children"
              onSearch={onFirmSearch}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {firmSelect.data.map(item => (
                <Option key={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Banka"
            name="bankId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="Seçiniz."
              optionFilterProp="children"
              onChange={onBankChange}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankDropdown.map(item => (<Option key={item.id} value={item.id}>{item.name}</Option>))}
            </Select>
          </Form.Item>

          <Form.Item
            name="currencyId"
            label="Para Birimi"
            rules={[{ required: true }]}
          >
            <Select
              allowClear
              showSearch
              defaultValue={1}
              value={1}
              onChange={onChangeCurrencyId}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {currencySelect.data.map(({ id, code }) => (
                <Select.Option key={id} value={id}>
                  {code}
                </Select.Option>
              ))}

            </Select>
          </Form.Item>

          <Form.Item
            label="Iban"
            name="iban"
            rules={accountNumber?.length < 5 ? [{ required: true },] : null}
          >
            <Input type="text" maxLength="26" value={iban} onChange={handleIban} />
          </Form.Item>

          <Form.Item
            label="Banka Şubesi"
            name="bankBranchId"
            rules={iban?.length < 20 ? [{ required: true },] : null}
          >
            <Select
              showSearch
              placeholder="Seçiniz"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankBranchDropdown.map(item => (
                <Option key={item.id} value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Hesap Numarası"
            name="accountNumber"
            rules={iban?.length < 20 ? [{ required: true }, { min: 7 }] : null}
          >
            <Input maxLength="17" onInput={maxLengthCheck}
              value={accountNumber}
              onChange={handleAccountNumber} />
          </Form.Item>

          <Form.Item
            label="Geçerli Hesap"
            name="isDefault"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>

          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Güncelle
            </Button>
          </Col>

        </Col>
      </Row>
    </Form>
  )
}
export default FirmAccountUpdate
